import React, { useState } from "react";

function LoginPage(props) {
    // Stato per capire se siamo nella modalità Login (true) o Registrazione (false)
    const [isLoginMode, setIsLoginMode] = useState(true);

    // Campi del form
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [nome, setNome] = useState("");
    const [cognome, setCognome] = useState("");
    const [codiceFiscale, setCodiceFiscale] = useState("");

    // --- FUNZIONI DI VALIDAZIONE ---
    const validaCodiceFiscale = (cf) => {
        const regexCF = /^[A-Z0-9]{16}$/;
        return regexCF.test(cf.toUpperCase());
    };

    const validaPassword = (pwd) => {
        const haMaiuscola = /[A-Z]/.test(pwd);
        const haNumero = /[0-9]/.test(pwd);
        return haMaiuscola && haNumero;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // 1. Validazione base dei campi prima di inviare la richiesta
        if (isLoginMode) {
            if (!username.trim() || !password.trim()) {
                alert("Compila tutti i campi!");
                return;
            }
        } else {
            if (!username.trim() || !password.trim() || !nome.trim() || !cognome.trim() || !codiceFiscale.trim()) {
                alert("Compila tutti i campi di registrazione!");
                return;
            }

            // CONTROLLO CODICE FISCALE
            if (!validaCodiceFiscale(codiceFiscale)) {
                alert("Il codice fiscale inserito non è valido. Deve essere esattamente di 16 caratteri alfanumerici.");
                return;
            }

            // CONTROLLO PASSWORD (almeno una maiuscola e un numero)
            if (!validaPassword(password)) {
                alert("La password deve contenere almeno una lettera maiuscola e un numero.");
                return;
            }
        }

        // 2. Scegliamo la porta (endpoint) del postino Flask a cui bussare
        const endpoint = isLoginMode ? '/api/login' : '/api/register';

        // 3. Prepariamo il pacchettino con i dati dentro un oggetto JavaScript
        const datiDaSpedire = isLoginMode 
            ? { username: username, password: password } 
            : { username: username, password: password, nome: nome, cognome: cognome, codiceFiscale: codiceFiscale };

        try {
            // 4. SPEDIZIONE! Mandiamo il pacco al server Flask
            //const rispostaDelServer = await fetch('http://localhost:5001' + endpoint, {
            const rispostaDelServer = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(datiDaSpedire),
            });

            // 5. Apriamo la risposta che ci manda indietro il postino Flask
            const risultato = await rispostaDelServer.json();

            if (rispostaDelServer.ok && risultato.success) {
                if (isLoginMode) {
                    // SE IL LOGIN È OK: Entriamo nell'app!
                    if (props.onLoginSuccess) {
                        props.onLoginSuccess(risultato.codice_fiscale);
                    }
                } else {
                    // SE LA REGISTRAZIONE È OK: Avvisiamo e torniamo al login
                    alert("Registrazione avvenuta con successo!");
                    setIsLoginMode(true);
                    setPassword("");
                    setNome("");
                    setCognome("");
                    setCodiceFiscale("");
                }
            } else {
                // SE LA REGISTRAZIONE O IL LOGIN FALLISCONO (es. username già esistente): Mostriamo l'errore del server
                alert(risultato.message || "Credenziali non valide o errore durante l'operazione.");
            }

        } catch (errore) {
            // Se il server non è attivo o c'è un problema di rete
            console.error("Errore di connessione:", errore);
            alert("Impossibile contattare il Server!");
        }
    };

    return (
        <div style={styles.fullscreenOverlay}>
            <div style={styles.loginCard}>
                <h1 style={styles.title}>Sono Povero</h1>
                <p style={styles.subtitle}>
                    {isLoginMode ? "Accedi per gestire le tue finanze" : "Crea un nuovo account"}
                </p>
                
                <form onSubmit={handleSubmit} style={styles.form}>
                    {/* Campi visibili SOLO in modalità Registrazione */}
                    {!isLoginMode && (
                        <>
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Nome</label>
                                <input 
                                    type="text" 
                                    placeholder="Il tuo nome" 
                                    value={nome}
                                    onChange={(e) => setNome(e.target.value)}
                                    style={styles.input}
                                    required 
                                />
                            </div>

                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Cognome</label>
                                <input 
                                    type="text" 
                                    placeholder="Il tuo cognome" 
                                    value={cognome}
                                    onChange={(e) => setCognome(e.target.value)}
                                    style={styles.input}
                                    required 
                                />
                            </div>

                            <div style={styles.inputGroup}>
                                <label style={styles.label}>Codice Fiscale</label>
                                <input 
                                    type="text" 
                                    placeholder="Il tuo codice fiscale" 
                                    value={codiceFiscale}
                                    onChange={(e) => setCodiceFiscale(e.target.value.toUpperCase())}
                                    style={styles.input}
                                    required 
                                />
                            </div>
                        </>
                    )}

                    {/* Campi comuni per Login e Registrazione */}
                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Username</label>
                        <input 
                            type="text" 
                            placeholder="Il tuo username" 
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            style={styles.input}
                            required 
                        />
                    </div>

                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Password</label>
                        <input 
                            type="password" 
                            placeholder="••••••••" 
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            style={styles.input}
                            required 
                        />
                    </div>
                    
                    <button type="submit" style={styles.loginBtn}>
                        {isLoginMode ? "Accedi" : "Registrati"}
                    </button>
                </form>

                {/* Testo e pulsante per cambiare vista */}
                <div style={styles.switchContainer}>
                    <span style={styles.switchText}>
                        {isLoginMode ? "Non hai un account?" : "Hai già un account?"}
                    </span>
                    <button 
                        type="button" 
                        onClick={() => setIsLoginMode(!isLoginMode)} 
                        style={styles.switchBtn}
                    >
                        {isLoginMode ? "Registrati" : "Torna al Login"}
                    </button>
                </div>
            </div>
        </div>
    );
}

// Stili grafici
const styles = {
    fullscreenOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: '#0f172a',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        overflowY: 'auto',
        padding: '20px 0',
    },
    loginCard: {
        background: '#1e293b',
        padding: '30px 40px',
        borderRadius: '12px',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.5)',
        textAlign: 'center',
        color: '#ffffff',
        border: '1px solid #334155',
        width: '100%',
        maxWidth: '400px',
    },
    title: {
        fontSize: '1.8rem',
        fontWeight: 'bold',
        marginBottom: '4px',
        textTransform: 'uppercase',
        fontStyle: 'italic',
    },
    subtitle: {
        color: '#94a3b8',
        marginBottom: '20px',
        fontSize: '0.95rem',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
    },
    inputGroup: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
    },
    label: {
        fontSize: '0.85rem',
        marginBottom: '4px',
        color: '#cbd5e1',
        fontWeight: '500',
    },
    input: {
        padding: '10px 12px',
        borderRadius: '6px',
        border: '1px solid #475569',
        background: '#0f172a',
        color: '#ffffff',
        fontSize: '0.95rem',
        outline: 'none',
    },
    loginBtn: {
        width: '100%',
        padding: '12px',
        marginTop: '8px',
        backgroundColor: '#22c55e',
        color: '#0f172a',
        border: 'none',
        borderRadius: '6px',
        fontWeight: 'bold',
        fontSize: '1rem',
        cursor: 'pointer',
    },
    switchContainer: {
        marginTop: '16px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '8px',
        fontSize: '0.85rem',
    },
    switchText: {
        color: '#94a3b8',
    },
    switchBtn: {
        background: 'none',
        border: 'none',
        color: '#22c55e',
        fontWeight: 'bold',
        cursor: 'pointer',
        padding: 0,
        fontSize: '0.85rem',
    }
};

export default LoginPage;
